import CryptoJS from 'crypto-js';

export default {
  AES_KEY: 'rongdakeji__0826', // 秘钥
  encode(data) {
    // 加密
    const key = CryptoJS.enc.Utf8.parse(this.AES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(this.AES_KEY);
    const str = typeof data === 'string' ? data : JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(str, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
      iv
    });
    return encryptedData.toString();
  },
  decode(code) {
    // 解密
    const key = CryptoJS.enc.Utf8.parse(this.AES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(this.AES_KEY);
    const encryptedHexStr = CryptoJS.enc.Base64.parse(code);
    const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
      iv,
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
  },
};



// WEBPACK FOOTER //
// ./src/utils/crypto.js